import { Injectable, computed, inject, signal } from '@angular/core';
import { Observable } from 'rxjs';
import { globalConfig } from '../utils/globalConfig';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class GuardService {
  private http = inject(HttpClient);

  #stateUsuarioData = signal<any>({
    nombreCompleto: String,
    usuario: {},
    cuenta: {},
    tipoPago: {},
    tipoUsuarioId: null,
  });

  public usuarioData = computed(() => this.#stateUsuarioData());

  constructor() {}

  authenticated(): Observable<object> {
    return this.http.get('/auth-empresarial/validate-token');
  }

  setToken(token: string) {
    sessionStorage.setItem(globalConfig.tokenApi, token);
  }
  /**
   * "skip-Interceptor" sive de bandera para saltar el interceptor http-interceptor.interceptor
   * la variable "mensaje" se muestra en el mensaje de error del unauthorized.interceptor
   * @param token
   * @returns
   */
  validateToken(token: string): Observable<object> {
    const mensaje = 'Ruta no valida, intente nuevamente.';
    return this.http.get('/auth-empresarial/validate-token', {
      headers: new HttpHeaders({
        'skip-Interceptor': mensaje,
        Authorization: `Bearer ${token}`,
      }),
    });
  }

  getTemporalToken(key: string) {
    return this.http.get(`/usuario-cuenta-empresarial/validate-token/${key}`);
  }

  setUserData(cuenta: any, usuario: any) {
    const current = this.#stateUsuarioData();
    const { usuarioCuentaEmpresarial, usuarioCuentaEmpresarialRelaciones, ...usuarioPrincipal } = usuario;
    const usuarioFront = { ...usuarioPrincipal, usuarioCuentaEmpresarial: usuarioCuentaEmpresarial?.[0] ?? {} };
    const usuarioCuentaEmpresarialActual = usuarioCuentaEmpresarial?.[0] ?? current.usuarioCuentaEmpresarial ?? {};
    const nombreCompleto = `${usuarioCuentaEmpresarialActual?.nombres ?? ''} ${usuarioCuentaEmpresarialActual?.apellidos ?? ''}`.trim();

    const tipoUsuarioId =
      usuarioCuentaEmpresarialRelaciones?.find(
        (item: any) => item.usuarioCuentaEmpresarial?.id === usuarioCuentaEmpresarial?.[0]?.id,
      )?.tipoUsuarioId?.id ?? usuario?.tipoUsuarioId;

    this.#stateUsuarioData.set({
      nombreCompleto: !nombreCompleto ? usuario?.nombreCompleto : nombreCompleto,
      usuario: usuarioFront,
      usuarioCuentaEmpresarial,
      cuenta,
      primerInicio: usuarioCuentaEmpresarial[0]?.primerInicio ?? current.primerInicio,
      fechaNacimiento: usuarioCuentaEmpresarial[0]?.fechaNacimiento ?? current.fechaNacimiento,
      tipoPago: cuenta?.tipoPago ?? current.tipoPago,
      tipoUsuarioId,
    });
  }
  updateUsuarioData(usuario: any) {
    this.#stateUsuarioData.update((current) => {
      return {
        ...current,
        nombreCompleto: `${usuario.usuarioCuentaEmpresarial?.[0]?.nombres} ${usuario.usuarioCuentaEmpresarial?.[0]?.apellidos}`,
        usuario: {
          ...current.usuario,
          ...usuario,
        },
        tipoUsuarioId: usuario?.tipoUsuarioId,
      };
    });
  }

  setUsuarioPreLogin(usuario: any) {
    this.#stateUsuarioData.set({
      nombreCompleto: '',
      usuario,
      cuenta: {},
      tipoPago: {},
    });
  }

  resetUsuarioData() {
    this.#stateUsuarioData.set({
      nombreCompleto: String,
      usuario: {},
      cuenta: {},
      tipoPago: {},
    });
  }

  updateCuentaData(cuenta: any) {
    this.#stateUsuarioData.update((current) => ({
      ...current,
      cuenta,
    }));
  }

}
